import React, { useState } from 'react'
import {
  Switch,
  Route,
  useHistory,
} from 'react-router-dom'
import {
  makeStyles,
} from '@material-ui/core'
import {
  CSSTransition,
  TransitionGroup
} from 'react-transition-group'
import './App.css'
import NavFabs from '../components/NavFabs'
import TopDrawer from '../components/TopDrawer'
import projectList from '../components/projectList'

const transitions = {
  basic: 'all 250ms',
  in: 'all 225ms cubic-bezier(0, 0, 0.2, 1) 0ms',
  out: 'all 195ms cubic-bezier(0.4, 0, 0.6, 1) 0ms',
}

const createNavButtons = (pos, theme) => {
  let base = {
    top: '50%',
    position: 'fixed',
    marginTop: '-28px',
    transition: transitions.basic,
    zIndex: 5000,
    [pos.toLowerCase()]: 0,
    ['margin' + pos]: '-36px',
    '&:hover': {
      ['margin' + pos]: theme.spacing(0.5),
    },
    [theme.breakpoints.down('md')]: {
      display: 'none',
    }
  }

  return { ...base }
}

const useStyles = makeStyles(theme => ({
  drawerIcon: {
    top: 0,
    left: '50%',
    position: 'fixed',
    marginTop: '-28px',
    marginLeft: '-28px',
    zIndex: 5000,
    '& > span.MuiFab-label': {
      transform: `translate(0, ${theme.spacing(1)})`,
      transition: transitions.out,
    },
    '&:hover > span.MuiFab-label > svg': {
      width: '2.15rem',
      height: '2.15rem',
    },
  },
  drawerIconClosed: {
    transition: transitions.out,
  },
  drawerIconOpened: {
    transition: transitions.in,
    top: '150px',
    '& > span.MuiFab-label': {
      transform: 'translate(0, 0) rotateX(180deg)',
      transition: transitions.in,
    }
  },
  drawerRoot: {
    '& > div.MuiPaper-root': {
      minHeight: '150px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'row',
      backgroundColor: theme.palette.warning.light,
      overflow: 'hidden',
    }
  },
  drawerButton: {
  },
  navIconNext: createNavButtons('Right', theme),
  navIconBefore: createNavButtons('Left', theme),
  appContainer: {
    margin: 0,
    padding: 0,
    border: 0,
    maxWidth: '100vw',
    minHeight: '100vh',
    boxSizing: 'bordex-box',
  },
}))

const App = props => {
  const classes = useStyles()
  const history = useHistory()
  const [drawer, setDrawer] = useState(false)

  const changeRoute = (path, isId = false) => {
    setDrawer(false)
    if (isId) {
      history.push(projectList[path].path)
      return
    }
    history.push(path)
  }

  const getProjectId = path => projectList.indexOf(
    projectList.find(_ => _.path === path)
  )

  const goToPrevProject = path => {
    let prevId = (getProjectId(path) - 1) < 0 ?
      projectList.length - 1 : getProjectId(path) - 1
    changeRoute(projectList[prevId].path)
  }

  const goToNextProject = path => {
    let nextId = (getProjectId(path) + 1) < projectList.length ?
      (getProjectId(path) + 1) : 0
    changeRoute(projectList[nextId].path)
  }

  return (
    <Route render={({ location }) => (
      <React.Fragment>
        <NavFabs
          drawer={drawer}
          setDrawer={setDrawer}
          classes={classes}
          prev={goToPrevProject}
          next={goToNextProject}
          path={props.location.pathname}
        />
        <TopDrawer
          drawer={drawer}
          setDrawer={setDrawer}
          classes={classes}
          projectList={projectList}
          path={getProjectId(props.location.pathname)}
          changeRoute={changeRoute}
        />
        <TransitionGroup>
          <CSSTransition
            key={location.key}
            timeout={300}
            classNames='projectChange'>
            <Switch location={location}>
              {projectList.map(project => (
                <Route
                  exact={project.path === '/' ? true : false}
                  key={project.path}
                  path={project.path}
                  component={project.component}
                />
              ))}
            </Switch>
          </CSSTransition>
        </TransitionGroup>
      </React.Fragment>
    )} />
  )
}

export default App